import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

//Estilos
import './InputBadge.css';

function InputBadge({ type, dataArray, onAdd, onDelete }) {
    const {
        register,
        reset,
        handleSubmit,
        watch,
        setError,
        formState: { errors },
    } = useForm();

    return (
        <>
            <div className="div-input_badge">
                <div className="badge-input_container">
                    <input
                        className="input-badge"
                        {...register('nrosViñedos', {
                            required: 'Debe ingresar un número de viñedo',
                            validate: {
                                minLength: (value) =>
                                    value.length === 8 ||
                                    value.length === 9 ||
                                    'El número de viñedo debe tener entre 8 y 9 dígitos',
                                exisitingVineyard: (value) =>
                                    !dataArray.some(
                                        (data) => data.data == value
                                    ) || 'El número de viñedo ya existe',
                            },
                        })}
                        type={type}
                    />
                </div>
                <button
                    className="btn btn-primary"
                    onClick={handleSubmit(onAdd)}
                >
                    Agregar
                </button>
            </div>
            {errors.nrosViñedos && (
                <small className="form__error">
                    {errors.nrosViñedos?.message}
                </small>
            )}
            {dataArray && dataArray.length > 0 && (
                <div className="div-badges">
                    {dataArray.map((data, i) => {
                        return (
                            <small key={`data${i}`} className="small-badge">
                                {data.data}
                                <i
                                    className="i-badge"
                                    id={data.id}
                                    onClick={(e) => onDelete(e.target.id)}
                                >
                                    X
                                </i>
                            </small>
                        );
                    })}
                </div>
            )}
        </>
    );
}

export default InputBadge;
